import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import { pairwise } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { pipe } from 'rxjs';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {

  constructor(
    private router: Router,
    private titleService: Title,
  ) {
    this.router.events.pipe(pairwise()).subscribe((e) => {
      if (!environment.production) {
        console.log(e);
      }
    });

    // set title name from environments
    this.titleService.setTitle(environment.siteName);

  }
}
